import Network from '@/services/network'

export default function handleAdmin(){

    const network = new Network;

    const storeOpenDeal = (data) => {
        return network.api('post', '/sale-pipeline/deal', data);
    }

    const storeQuotation = (data) => {
        return network.api('post', '/sale-pipeline/store-quotation', data);
    }

    const fetchPipelineList = (query) => {
        return network.api('get', '/sale-pipeline/deal' + query);
    }

    const fetchDealNameList = (query) => {
        return network.api('get', '/sale-pipeline/deal-name-list' + query);
    }

    const fetchQuotationList = (query) => {
        return network.api('get', '/sale-pipeline/quotation-list' + query);
    }

    const fetchPipelineById = (id, query) => {
        return network.api('get', `/sale-pipeline/deal/${id}` + query);
    }

    const fetchQuotationById = (id, query) => {
        return network.api('get', `/sale-pipeline/quotation/${id}` + query);
    }

    const updatePipeline = (id, query) => {
        return network.api('put', `/sale-pipeline/deal/` + id, query);
    }

    const updateQuotation = (id, query) => {
        return network.api('post', `/sale-pipeline/update-quotation/` + id, query);
    }

    //function to format the form data
    const formatFormData = (formData) => {
        const payload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (key === 'item_details' || key === 'attachments') {
                return;
            }
          
            Array.isArray(value)
                ? value.forEach((item, i) => payload.append(`${key}[${i}]`, item))
                : payload.append(key, value !== null ? value : '');
        });

        payload.append('item_details', JSON.stringify(formData.item_details));

        return payload;
    }
    
    // function to handle attachment
    const handleAttachments = (formData, attachments) =>  {
        const previousFileIds = attachments
            .filter(attachment => typeof attachment === 'object' && attachment.hasOwnProperty('id'))
            .map(attachment => attachment.id);

        attachments.forEach((attachment, index) => {
            if (typeof attachment !== 'object' || !attachment.hasOwnProperty('id')) {
                formData.append(`attachments[${index}]`, attachment);
            }
        });

        if (previousFileIds.length) {
            formData.append('previous_file_ids', JSON.stringify(previousFileIds));
        }
    }

    return {
        storeOpenDeal,
        fetchPipelineList,
        fetchPipelineById,
        updatePipeline,
        storeQuotation,
        fetchQuotationList,
        fetchQuotationById,
        updateQuotation,
        fetchDealNameList,
        formatFormData,
        handleAttachments
    }
}